// Web mock for react-native-onesignal
const noop = () => {};
const noopAsync = async () => {};

const pushSubscription = {
  getIdAsync: async () => null,
  getTokenAsync: async () => null,
  optedIn: false,
  id: null,
  token: null,
  addEventListener: noop,
  removeEventListener: noop,
};

const Notifications = {
  addEventListener: noop,
  removeEventListener: noop,
  requestPermission: async (fallbackToSettings?: boolean) => false,
  canRequestPermission: async () => false,
  hasPermission: () => false,
  permissionNative: () => 1,
  getPermissionAsync: async () => false,
  clearAll: noop,
};

const User = {
  pushSubscription,
  addAlias: noop,
  removeAlias: noop,
  addAliases: noop,
  removeAliases: noop,
  addEmail: noop,
  removeEmail: noop,
  addSms: noop,
  removeSms: noop,
  addTag: noop,
  addTags: noop,
  removeTag: noop,
  removeTags: noop,
  getTags: async () => ({}),
};

const InAppMessages = {
  addEventListener: noop,
  removeEventListener: noop,
  addTrigger: noop,
  addTriggers: noop,
  removeTrigger: noop,
  removeTriggers: noop,
  clearTriggers: noop,
  paused: false,
};

const Debug = {
  setLogLevel: noop,
  setAlertLevel: noop,
};

const Location = {
  requestPermission: noopAsync,
  isShared: false,
};

const Session = {
  addOutcome: noop,
  addUniqueOutcome: noop,
  addOutcomeWithValue: noop,
};

export const OneSignal = {
  initialize: noop,
  login: noopAsync,
  logout: noopAsync,
  setConsentGiven: noop,
  setConsentRequired: noop,
  Notifications,
  User,
  InAppMessages,
  Debug,
  Location,
  Session,
};

export default OneSignal;
